import { useRef, useEffect } from 'react';

interface TextareaQuestionProps {
  questionId: number;
  value: string | undefined;
  onChange: (questionId: number, value: string) => void;
}

const TextareaQuestion = ({ questionId, value, onChange }: TextareaQuestionProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const prevHeightRef = useRef<number | null>(null);

  const resize = () => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = 'auto'; // 높이 리셋
    // 보더값(2px) 보정
    el.style.height = `${el.scrollHeight + 2}px`; 
  };
  
  // handleChange에서도 복잡한 분기 없이 resize()만 호출하면 됩니다.

  useEffect(() => {
    resize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(questionId, e.target.value);
  
    const el = textareaRef.current;
    if (!el) return;
  
    if (!e.target.value) {
      // 내용이 완전히 비면 초기 상태로 리셋
      prevHeightRef.current = null;
      el.style.height = 'auto';
      return;
    }
  
    resize(); // 내용이 있을 때만 grow-only 로직
  };
  return (
<textarea
  ref={textareaRef}
  rows={1}
  className="w-full resize-none rounded-[10px] border border-[#111111] bg-white px-4 py-2 font-Pretendard text-[15px] font-medium leading-[140%] tracking-normal text-[#111111] placeholder:text-gray-400 focus:bg-[#D0FFEB] focus:outline-none"
  placeholder="답변을 입력해주세요"
  value={value || ''}
  onChange={handleChange}
/>
  );
};

export default TextareaQuestion;
